import { Node, mergeAttributes } from '@tiptap/core';

const SegmentContainer = Node.create({
  name: 'segmentContainer',

  group: 'block',
  content: 'block*',
  draggable: true,

  addAttributes() {
    return {
      segmentType: {
        default: null,
      },
      segmentId: {
        default: null,
      },
      itinerary: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute('data-itinerary');
          return value ? JSON.parse(value) : null;
        },
        renderHTML: (attributes) => {
          if (!attributes.itinerary) return {};
          return {
            itinerary: JSON.stringify(attributes.itinerary),
          };
        },
      },
      product: {
        default: null,
        parseHTML: (element) => {
          const value = element.getAttribute('data-product');
          return value ? JSON.parse(value) : null;
        },
        renderHTML: (attributes) => {
          if (!attributes.product) return {};
          return {
            product: JSON.stringify(attributes.product),
          };
        },
      },
      tripId: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-trip-id'),
        renderHTML: (attributes) => {
          if (!attributes.tripId) return {};
          return {
            tripId: attributes.tripId,
          };
        },
      },
      selectedRoomIndex: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-selectedRoomIndex'),
        renderHTML: (attributes) => {
          if (!attributes.selectedRoomIndex) return {};
          return {
            selectedRoomIndex: attributes.selectedRoomIndex,
          };
        },
      },
      rateOption: {
        default: null,
        parseHTML: (element) => element.getAttribute('rateOption'),
        renderHTML: (attributes) => {
          if (!attributes.rateOption) return {};
          return {
            rateOption: attributes.rateOption,
          };
        },
      },
      itineraryDetail: {
        default: null,
        parseHTML: (element) => element.getAttribute('itineraryDetail'),
        renderHTML: (attributes) => {
          if (!attributes.itineraryDetail) return {};
          return {
            itineraryDetail: attributes.itineraryDetail,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-segment-container]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-segment-container': '',
        class: 'segment-container',
        style: 'margin-bottom: 32px;',
      }),
      0,
    ];
  },
});

export default SegmentContainer;
